import { localizer } from "@stormglass/game-localization";

import { useGameHost, useGameState } from "../game/GameContext";

export function GameHud(): React.JSX.Element {
  const host = useGameHost();
  const { ui } = useGameState();
  const integrity = Math.max(0, ui.integrity / Math.max(1, ui.maxIntegrity));
  return (
    <header className="game-hud" aria-label="Game status">
      <div className="hud-round">
        <span className="hud-label">ROUND</span>
        <strong>{String(ui.round).padStart(2, "0")}</strong>
        <small>{ui.quotaRemaining} INBOUND</small>
      </div>
      <div className="hud-integrity">
        <div className="hud-integrity__header">
          <span>{localizer.t("hud.integrity")}</span>
          <strong>
            {Math.ceil(ui.integrity)} / {ui.maxIntegrity}
          </strong>
        </div>
        <div
          className="integrity-bar"
          role="progressbar"
          aria-label="Chamber integrity"
          aria-valuemin={0}
          aria-valuemax={ui.maxIntegrity}
          aria-valuenow={ui.integrity}
        >
          <span style={{ transform: `scaleX(${String(integrity)})` }} />
        </div>
        {ui.shield > 0 && (
          <div className="shield-readout">◇ {Math.ceil(ui.shield)} SHIELD</div>
        )}
      </div>
      {ui.bossSecondsRemaining !== null ? (
        <div className="boss-clock">
          <span>IMPACT</span>
          <strong>{Math.ceil(ui.bossSecondsRemaining)}</strong>
          <small>SECONDS</small>
        </div>
      ) : (
        <div className="hud-controls">
          <div className="speed-control" aria-label="Simulation speed">
            <button
              type="button"
              className={ui.speed === 1 ? "is-active" : ""}
              aria-pressed={ui.speed === 1}
              onClick={() => {
                host.command({ type: "set-game-speed", speed: 1 });
              }}
            >
              ×1
            </button>
            <button
              type="button"
              className={ui.speed === 2 ? "is-active" : ""}
              aria-pressed={ui.speed === 2}
              onClick={() => {
                host.command({ type: "set-game-speed", speed: 2 });
              }}
            >
              ×2
            </button>
          </div>
          <button
            className="pause-button"
            type="button"
            aria-label={ui.paused ? "Resume game" : "Pause game"}
            onClick={() => {
              host.command({ type: ui.paused ? "resume-run" : "pause-run" });
            }}
          >
            {ui.paused ? "▶" : "Ⅱ"}
          </button>
        </div>
      )}
    </header>
  );
}
